import { PropsWithChildren } from 'react';
import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';
import { Icon, useTheme } from '@ui-kitten/components';

import ButtonMobile from '../../../../Components/Button';
import ButtonWeb from '../../../../Components/Web/Intereaction/ScaleButtonAnimation';
import constants from '../../../../Config/constants';
import ThemeColor from '../../../../Theme/colors';
import ThemeStyle from '../../../../Theme/styles';

const Button = constants.isWeb ? ButtonWeb : ButtonMobile;

type Props = {
  disableNext: boolean;
  disablePrev: boolean;
  onNext: () => void;
  onPrev: () => void;
};

const ChevronButton = ({ direction, ...rest }) => {
  const theme = useTheme();
  return (
    // @ts-ignore: children ts error, Button is not typescript file
    <Button {...rest} hitSlop={10} plain>
      <View
        style={[
          styles.arrowButton,
          { backgroundColor: theme['color-info-500'] },
        ]}
      >
        <Icon
          name={`chevron-${direction}`}
          fill={ThemeColor.white}
          style={{ width: 30, height: 30 }}
        />
      </View>
    </Button>
  );
};

const BannerArrow = ({
  children,
  disableNext,
  disablePrev,
  onNext,
  onPrev,
}: PropsWithChildren<Props>) => {
  return (
    <View>
      <View style={{ zIndex: 1 }}>{children}</View>
      <View
        dataSet={{ media: ids.arrowContainer }}
        style={styles.arrowContainer}
      >
        <ChevronButton
          disabled={disablePrev}
          direction="left"
          onPress={onPrev}
        />
        <ChevronButton
          disabled={disableNext}
          direction="right"
          onPress={onNext}
        />
      </View>
    </View>
  );
};

export const { ids, styles } = StyleSheet.create({
  arrowContainer: {
    ...ThemeStyle.flexDirectionRowCenterSpaceBetween,
    display: 'none',
    position: 'absolute',
    top: 0,
    left: -44,
    right: -44,
    bottom: 5,
    [`@media (min-width: 1280px)`]: {
      display: 'flex',
    },
  },
  arrowButton: {
    borderRadius: 50,
    paddingHorizontal: 2,
    paddingVertical: 2,
  },
});

export default BannerArrow;
